import { call, put, takeLatest } from "redux-saga/effects";
import { SPSELECTS } from "../../InterfacesTypes/enums";
import { spGet } from "../../utils/SharepointAPI";
import { getEnvironment } from "../../utils/utils";
import type { INavigationItemsMenu } from "../../InterfacesTypes/interfaces";
import {
  fetchFailure,
  fetchNavigationItems,
  fetchStart,
  fetchSuccess,
} from "../reducers/NavigationItemsReducer";

const env = getEnvironment();

function* getNavigationMenuWorker() {
  try {
    yield put(fetchStart());
    const navigationItemsListUrl = `${env.listapi}/GetByTitle('NavigationItems')/Items?$top=5000&$select=${SPSELECTS.NAVIGATIONITEMS}`;
    const data: INavigationItemsMenu[] = yield call(
      spGet,
      navigationItemsListUrl
    );
    yield put(fetchSuccess(data));
  } catch (err: any) {
    yield put(fetchFailure(err?.message ?? "Något gick fel"));
  }
}

export function* navigationMenuSaga() {
  yield takeLatest(fetchNavigationItems.type, getNavigationMenuWorker);
}
